import styled, { css } from 'styled-components';
import { Container } from '@/components/ui/Container';
import { getInsideChrome } from '@/utils/colorSystem';

/** Wrapper for the entire page body */
export const LayoutWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;

/** Header area containing title/description and optional actions */
export const HeaderSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  color: ${({ theme }) => getInsideChrome(theme).featureNavFg};
`;

export const Description = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${({ theme }) => getInsideChrome(theme).featureNavFg};
  opacity: 0.75;
`;

export const ActionArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

/** Responsive grid for KPI cards */
export const CardsGrid = styled.div`
  display: grid;
  grid-gap: 24px;
  margin-bottom: 32px;
  grid-template-columns: repeat(${props => props.$columns || 1}, minmax(0, 1fr));

  @media (max-width: 1200px) {
    grid-template-columns: repeat(min(${props => props.$columns || 1}, 3), minmax(0, 1fr));
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(min(${props => props.$columns || 1}, 2), minmax(0, 1fr));
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
